import { render } from "./TripMustHaveServicesComponent.vue?vue&type=template&id=666f8641&scoped=true"
import script from "./TripMustHaveServicesComponent.vue?vue&type=script&lang=ts"
export * from "./TripMustHaveServicesComponent.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-666f8641"

export default script